import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@packages/api';

async function getCall(callId: number) {
  const res = await apiFetch(`/api/v17/calls/${callId}?legacyResponseFormat=false`);
  if (!res.ok) throw new Error(`Failed to fetch call: ${res.status}`);
  return res.json();
}

export function useCall(callId: number) {
  return useQuery({
    queryKey: ['call', callId],
    queryFn: () => getCall(callId),
    enabled: callId > 0,
  });
}
